<template>
  <div class="showcase-card-more-cards" v-if="cards.length > 0">
    <align class="header" flex>
      <h4 class="secondary-font">More in this collection</h4>

      <icon-link
        :as="isPublic ? 'nuxt-link' : 'router-link'"
        :to="`/showcase/${card.uid}?collectionId=${card.collectionId}`"
      >
        View all
      </icon-link>
    </align>

    <div v-if="isPublic" class="grid medium-up">
      <showcase-card
        v-for="card in cards"
        :key="card.id"
        as="nuxt-link"
        :card="card"
        :to="getCardTo(card.id)"
      />
    </div>

    <div class="list" :class="{ 'medium-down': isPublic }">
      <card-list-item
        v-for="card in cards"
        :key="card.id"
        :card="card"
        :to="getCardTo(card.id)"
        :as="isPublic ? 'nuxt-link' : 'router-link'"
      />
    </div>
  </div>
</template>

<script>
import Align from './Align';
import CardListItem from './CardListItem';
import IconLink from './IconLink';
import ShowcaseCard from './ShowcaseCard';

export default {
  components: {
    Align,
    CardListItem,
    IconLink,
    ShowcaseCard,
  },

  props: {
    card: Object,
    cards: Array,
    isPublic: Boolean,
  },

  methods: {
    getCardTo(id) {
      if (this.isPublic) {
        return `/showcase/card/${id}`;
      }

      const query = { ...this.$route.query };

      return {
        ...this.$route,
        query: {
          ...query,
          showcaseCardId: id,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.showcase-card-more-cards {
  padding-top: $gp;
  border-top: solid 1px var(--theme-border);
  margin-bottom: $gp * 1.5;
}

.header {
  margin-bottom: $gp * .25;

  h4 {
    margin-bottom: 0;
  }
}

.grid {
  @include grid-panel;
  margin-top: $gp * .75;
}

.list {
  margin: 0 (-$gp);
}
</style>
